import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from "../../../utils/queryClient";
import "../../../assets/stylesheets/global.css";

// Layout volontairement minimal (pas de Header/Footer du site) : ces pages
// sont des landings de vote autonomes. Le QueryClientProvider est requis par
// ReviewsForm (recherche de plaque + soumission).
const NomineeLayout = ({ children }: { children: React.ReactNode }) => (
  <QueryClientProvider client={queryClient}>
    <div className="min-h-screen flex flex-col bg-white">{children}</div>
  </QueryClientProvider>
);

export default NomineeLayout;
